module.exports = __webpack_public_path__ + "static/media/Illus-FoodOnItsWay.0e60a258.png";